import { MediaAttachmentTypes } from '~/constants';

const IMAGE_TYPES = [
  MediaAttachmentTypes.JPEG,
  MediaAttachmentTypes.IMAGE,
  MediaAttachmentTypes.GIF,
  MediaAttachmentTypes.JPG,
  MediaAttachmentTypes.PNG,
  MediaAttachmentTypes.WEBP,
];

export const isImageType = (type: string) => {
  return IMAGE_TYPES.find((t) => t === type.toUpperCase());
};
